import { Component, OnInit } from '@angular/core';
import { AlertMessageService } from '@app/_services/alert-message.service';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.css']
})
export class AlertMessageComponent implements OnInit {
  showAlert: boolean = false;
  description: String = '';
  body: String = '';

  constructor(private service: AlertMessageService) { }

  ngOnInit(): void {
    this.service.getAlertMessage().subscribe((data) => {
      if (data) {
        this.showAlert = true;
        this.description = data.description;
        this.body = data.body;
      }
    });
  }

}